import { render, staticRenderFns } from "./basecambiosestadocreditos.vue?vue&type=template&id=47a7947c"
import script from "./basecambiosestadocreditos.vue?vue&type=script&lang=js"
export * from "./basecambiosestadocreditos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports